import createPlugin from "./createPlugin";
import CallbirdRenderer from "./Renderer";
import CallbirdForm from "./Form";

const CallbirdPlugin = (settings) =>
    createPlugin({
        Renderer: CallbirdRenderer,
        Controls: CallbirdForm,
        ...settings,
    });

const Callbird = CallbirdPlugin();
export default Callbird;

export { CallbirdPlugin, CallbirdRenderer };
